import { render } from "./UserCard.vue?vue&type=template&id=66ea7ad0&scoped=true&ts=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=66ea7ad0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ea7ad0"]])

export default __exports__